module.exports = __webpack_public_path__ + "img/2.68d6b097.jpg";